/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext } from 'react';
import {
  FluidContainer,
  InputDate,
  SummaryCards,
  DashboardLeaderboardAndActivitySection,
} from '../../../components';
import { ARMcontext } from '../../../utils/context/context';
import { usePlayersDashboardFilters } from '../../../utils/hooks/playersDashboardFilters.hook';
import { useDashboardMetrics } from '../../../utils/hooks/useDashboardMetrics.hook';
import { PLAYERS_DASHBOARD_RANGE_OPTIONS } from '../../../utils/constants/dashboardDateRanges';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/icCalendar.svg';
import {
  DashboardPageWrapper,
  DashboardFiltersBar,
  DashboardFiltersRight,
  RangeTabs,
  RangeTab,
  RangeTabCustomIcon,
  DashboardSectionTitle,
} from './styles';

type PlayersTeamsDashboardPageProps = {
  playersGroup?: string;
  playerNameSearch?: string;
};

export default function PlayersTeamsDashboardPage({
  playersGroup,
  playerNameSearch,
}: PlayersTeamsDashboardPageProps = {}) {
  const { selectedTeam } = useContext(ARMcontext);
  const { rangePreset, startDate, endDate, setRangePreset, setDates } = usePlayersDashboardFilters();
  const { data: metrics, isLoading, isError } = useDashboardMetrics({
    teamId: (selectedTeam as any)?._id || (selectedTeam as any)?.id || null,
    rangePreset,
    playersGroup,
    search: playerNameSearch ?? '',
    startDate: startDate ? startDate.toISOString() : null,
    endDate: endDate ? endDate.toISOString() : null,
  });
  
  const activeRange =
    PLAYERS_DASHBOARD_RANGE_OPTIONS.find(option => option.id === rangePreset) ??
    PLAYERS_DASHBOARD_RANGE_OPTIONS[0];

  // overflow-x: auto on FluidContainer clips datepicker poppers; false + InputDate fixed popper fixes end-date calendar
  return (
    <FluidContainer overflow={false}>
      <DashboardPageWrapper>
        <DashboardFiltersBar>
          <DashboardSectionTitle>
            {selectedTeam?.name || 'Team Dashboard'}
          </DashboardSectionTitle>
          <DashboardFiltersRight>
            <RangeTabs>
              {PLAYERS_DASHBOARD_RANGE_OPTIONS.map(option => (
                <RangeTab
                  key={option.id}
                  type="button"
                  active={option.id === activeRange.id}
                  isCustom={option.id === 'custom'}
                  onClick={() => setRangePreset(option.id as any)}
                >
                  {option.title}
                  {option.id === 'custom' && (
                    <RangeTabCustomIcon active={option.id === activeRange.id}>
                      <CalendarIcon />
                    </RangeTabCustomIcon>
                  )}
                </RangeTab>
              ))}
            </RangeTabs>
            {rangePreset === 'custom' && (
              <InputDate
                showRange={true}
                closeIcon={false}
                dropdownPicker={true}
                date={startDate || new Date()}
                endDate={endDate || new Date()}
                setDate={(date: Date) => setDates(date, endDate || date)}
                setEndDate={(date: Date) => setDates(startDate || date, date)}
                minEndDate={startDate || undefined}
              />
            )}
          </DashboardFiltersRight>
        </DashboardFiltersBar>

        <DashboardLeaderboardAndActivitySection
          rangePreset={rangePreset}
          startDate={startDate}
          endDate={endDate}
          playersGroup={playersGroup}
          playerNameSearch={playerNameSearch}
          summaryCards={<SummaryCards metrics={metrics} isLoading={isLoading} isError={isError} rangePreset={rangePreset} />}
        />
      </DashboardPageWrapper>
    </FluidContainer>
  );
}
